<template>
  <div style="background-color: #d6eaff;height: 100%;">
    <div id="joystick-wrapper">
      <div id="joystick"></div>
    </div>
    <canvas ref="canvas"></canvas>
    <div ref="labelRendererDiv"></div>
    <video id="video1"></video>
    <video id="video2"></video>
    <video id="video3"></video>
    <video id="video4"></video>
    <audio id="audio" style="width: 1px;height: 1px;opacity: 0;" autoplay></audio>
  </div>
</template>

<script>
  import io from "socket.io-client";
  var socketUrl = 'http://' + location.host
   if ("https:" == document.location.protocol) {
       socketUrl = 'https://' + location.host
   }
  const socket = io(socketUrl,{
    transports: ["websocket"]
  });

  // const socket = io('http://192.168.31.204:39999', {
  //   transports: ["websocket"]
  // });

  // const socket = io('https://multi-online.fourdsoft.cn/',{ //可以连接
  //   transports: ["websocket"]
  // });

  import {
    getLoginUserInfoDataFn,
    sharedScreenFn,
    isTouchscreenDevice,
    createJoystick
  } from '@/utils/video.js'

  import * as THREE from 'three'
  import {
    OrbitControls
  } from 'three/examples/jsm/controls/OrbitControls.js'
  import {
    VertexNormalsHelper
  } from 'three/examples/jsm/helpers/VertexNormalsHelper.js'
  import Stats from 'stats.js';

  import {
    GLTFLoader
  } from 'three/examples/jsm/loaders/GLTFLoader.js';
  import * as SkeletonUtils from 'three/examples/jsm/utils/SkeletonUtils.js';
  import {
    CSS2DRenderer,
    CSS2DObject
  } from 'three/examples/jsm/renderers/CSS2DRenderer.js';

  import {
    CharacterControls
  } from '../assets/js/CharacterControls'
  import {
    CharacterControlsOther
  } from '../assets/js/CharacterControlsOther'


  export let manager = new THREE.LoadingManager();

  export default {
    name: 'HelloWorld',
    data() {
      return {
        cursorHoverObjects: [], //显示鼠标手势对象集合
        scene: null,
        player: null, //角色
        gltf: null, //角色参数
        playerAnimationsArr: [], //角色集合
        mixers: [],
        camera: null, //相机
        keysPressed: {}, //按键
        playerList: {}, //他人对象
        isPlay: false, //短时间内多次触发
        moveDirection: {
          left: 0, //左
          right: 0, //右
          forward: 0, //前
          back: 0, //后
        }
      }
    },
    mounted() {
      if (isTouchscreenDevice()) {
        createJoystick(document.getElementById('joystick-wrapper'));
        document.getElementById('joystick-wrapper').style.visibility = 'visible';
        document.getElementById('joystick').style.visibility = 'visible';
      }

      getLoginUserInfoDataFn(this); //调用用户信息接口 创建websocket
      var this_ = this;
      this_.socketIo(); //建立socketIo

      const stats = new Stats(); //右上角帧数fps
      document.body.appendChild(stats.dom);

      var characterControls,
        labelRenderer,
        renderer,
        controls;

      const canvas = this.$refs.canvas;
      const labelRendererDiv = this.$refs.labelRendererDiv;
      // let cursorHoverObjects = [];//显示鼠标手势对象集合
      let collideObjects = []; //碰撞检测对象
      this.player = new THREE.Group() //当前控制的角色

      const textureLoader = new THREE.TextureLoader();

      /**
       * Sizes
       */
      const sizes = {
        width: window.innerWidth,
        height: window.innerHeight
      }

      // Instantiate a loader
      const loader = new GLTFLoader(manager);



      function init() {
        initWebGLRenderer();
        initCSS2DRenderer();
        this_.initScene();
        initLights();
        initCamera();
        initControls();

        // 小球
        // let radius = 20;
        // const SphereGeometry = new THREE.SphereBufferGeometry( radius, 32, 32);
        // const SphereMaterial = new THREE.MeshStandardMaterial();
        // let sphere = new THREE.Mesh( SphereGeometry, SphereMaterial );

        // let pos = { x: 50, y: 20, z: 50 };

        // sphere.position.set( pos.x, pos.y, pos.z );
        // sphere.castShadow = true;//default is false
        // sphere.receiveShadow = true;
        // sphere.geometry.computeBoundingSphere();
        // sphere.geometry.computeBoundingBox();
        // scene.add( sphere );
        // collideObjects.push(sphere);
      }


      init()

      createPlane();
      createWallX(501, 220, 0);
      createWallX(-501, 220, 0);
      createWallZ(0, 220, 501);
      createWallZ(0, 220, -501);

      // this.createBillboard(
      //   0,
      //   200,
      //   -495,
      //   Math.PI * 2,
      //   'https://baidu.com',
      //   'static/textures/terpSolutions.png'
      // );
      this.createBillboard(
        495,
        200,
        0,
        Math.PI / 2 * 3,
        'https://baidu.com',
        'static/textures/games_fps.jpg'
      );
      this.createBillboard(
        -495,
        200,
        0,
        Math.PI / 2 * 1,
        'https://baidu.com',
        'static/textures/1666875370386.jpg'
      );
      // this.createBillboardVideo(
      //   0,
      //   200,
      //   495,
      //   Math.PI,
      //   // 'static/textures/videoPortfolio.mp4',
      //   '',
      //   'https://baidu.com'
      // )
      this.createBillboard(
        0,
        200,
        495,
        Math.PI,
        'https://baidu.com',
        'static/textures/terpSolutions.png'
      );


      //创建四面屏幕
      // this.createBillboardVideo(
      //   0,
      //   200,
      //   -495,
      //   Math.PI * 2,
      //   '',
      //   'https://baidu.com',
      //   'video1'
      // );

      this.createBillboard(
        0,
        220,
        -495,
        Math.PI * 2,
        'https://baidu.com',
        'static/textures/terpSolutions.png',
        'image1'
      );

      this.createBillboardVideo(
        0,
        220,
        -495,
        Math.PI * 2,
        '',
        'https://baidu.com',
        'video1'
      );

      // this.createBillboardVideo(
      //   495,
      //   200,
      //   0,
      //   Math.PI /2 * 3,
      //  '',
      //  'https://baidu.com',
      //  'video2'
      // );
      // this.createBillboardVideo(
      //   -495,
      //   200,
      //   0,
      //   Math.PI /2 * 1,
      //   '',
      //   'https://baidu.com',
      //  'video3'
      // );
      // this.createBillboardVideo(
      //   0,
      //   200,
      //   495,
      //   Math.PI,
      //   // 'static/textures/videoPortfolio.mp4',
      //   '',
      //   'https://baidu.com',
      //  'video4'
      // )

      // createBillboardVideo(495, 150, 0, Math.PI/2*3, 'static/textures/video01.mp4', 'https://baidu.com')



      //角色
      loader.load(
        'static/model/Xbot.glb',
        function(gltf) {
          // console.log(gltf)
          gltf.scene.traverse(function(object) {
            if (object.isMesh) object.castShadow = true;
          });
          let pos = {
            x: 0,
            y: 0,
            z: 0
          };
          let scale = {
            x: 50,
            y: 50,
            z: 50
          }
          gltf.scene.scale.set(scale.x, scale.y, scale.z);

          this_.gltf = gltf;

          // let idle = gltf.animations[2];
          // let run = gltf.animations[3];
          // let walk = gltf.animations[6];

          // var createPlayer = function(player, pos){
          //   const model = SkeletonUtils.clone( gltf.scene );
          //   model.rotation.y += Math.PI //旋转180度
          //   player.mixer = new THREE.AnimationMixer(model);

          //   player.animationsMap = new Map();
          //   player.animationsMap.set(idle.name, player.mixer.clipAction(idle))
          //   player.animationsMap.set(run.name, player.mixer.clipAction(run))
          //   player.animationsMap.set(walk.name, player.mixer.clipAction(walk))

          //   player.add(model)
          //   player.layers.enableAll();
          //   this_.create2DObject(player);
          //   player.position.set(pos.x, pos.y, pos.z);
          //   this_.mixers.push(player.mixer)

          // }

          // player.name = '张三';
          // this_.player.name = this_.username;

          this_.player.name = this_.$route.query.name;

          // this_.player.name = '用户：'+new Date().getTime();
          console.log("创建自己：" + this_.player.name)

          this_.createPlayer(this_.player, pos);
          this_.scene.add(this_.player)

          characterControls = new CharacterControls(
            this_.player, this_.player.mixer, this_.player.animationsMap,
            controls, this_.camera, 'idle', collideObjects); //idle

          createCameras()

          function createCameras() {
            let childNode = new THREE.Object3D()
            let playerNode = childNode.clone()
            childNode.name = "childNode"
            playerNode.name = "playerNode"
            this_.player.add(playerNode)
          }
          tick()
        })



      function initLights() {
        // 添加环境光
        const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
        this_.scene.add(ambientLight);

        // 添加点光源
        const pointLight = new THREE.PointLight(0xffffff, 1);
        // pointLight.position.set(-600, 900, -100); // 设置平行光位置
        pointLight.castShadow = true;

        //Set up shadow properties for the light
        pointLight.shadow.mapSize.width = 2048;
        pointLight.shadow.mapSize.height = 2048;
        pointLight.shadow.camera.near = 0.1;
        pointLight.shadow.camera.far = 1000;
        // pointLight.shadow.camera.fov = 10;
        // pointLight.shadow.camera.focus = 100;
        pointLight.shadow.radius = 20; //阴影模糊度
        pointLight.lookAt(0, 0, 0);

        const samllBoll = new THREE.Mesh(
          new THREE.SphereBufferGeometry(20, 20, 20),
          new THREE.MeshBasicMaterial({
            color: 0xFFFFF0
          })
        );
        samllBoll.position.set(0, 340, 0);
        samllBoll.add(pointLight);
        this_.scene.add(samllBoll);

        // Create a helper for the shadow camera (optional)
        // const helper = new THREE.CameraHelper( pointLight.shadow.camera );//相机辅助线
        // scene.add( helper );
      }



      /**
       * Camera
       */
      function initCamera() {
        this_.camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 1, 2000)
        this_.camera.position.x = 0;
        this_.camera.position.y = 150;
        this_.camera.position.z = 250;
      }

      window.addEventListener('resize', () => {
        // Update sizes
        sizes.width = window.innerWidth
        sizes.height = window.innerHeight

        // Update camera
        this_.camera.aspect = sizes.width / sizes.height
        this_.camera.updateProjectionMatrix()

        // Update renderer
        if (renderer) {
          renderer.setSize(sizes.width, sizes.height)
        }
        labelRenderer.setSize(sizes.width, sizes.height);
      })


      /**
       * CSS2DRenderer
       */
      function initCSS2DRenderer() {
        labelRenderer = new CSS2DRenderer();
        labelRenderer.setSize(sizes.width, sizes.height);
        labelRenderer.domElement.style.position = 'absolute';
        labelRenderer.domElement.style.top = '0px';
        labelRendererDiv.appendChild(labelRenderer.domElement);
      }
      /**
       * Renderer
       */
      function initWebGLRenderer() {
        renderer = new THREE.WebGLRenderer({
          canvas: canvas,
          antialias: true
        })
        renderer.setSize(sizes.width, sizes.height)
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.shadowMap.enabled = true;
      }

      function initControls() {
        // Controls
        controls = new OrbitControls(this_.camera, labelRenderer.domElement)
        // 使动画循环使用时阻尼或自转 意思是否有惯性
        controls.enableDamping = true
        controls.minDistance = 200; //你能够将相机向内移动多少
        controls.maxDistance = 400; //你能够将相机向外移动多少
        controls.maxPolarAngle = Math.PI / 2 - 0.05; //你能够垂直旋转的角度的上限。
        controls.enableDamping = true; //启用阻尼（惯性）
        controls.dampingFactor = 0.05; //阻尼惯性系数
        controls.enablePan = false; //启用或禁用摄像机平移
        //是否可以缩放
        controls.enableZoom = true;

        controls.target = new THREE.Vector3(0, 1, 0)
        // controls.target.set( -400, 400, 400);//控制器的焦点
      }





      //create flat plane
      function createPlane() {
        // block properties
        let pos = {
          x: 0,
          y: -5,
          z: 0
        };
        let scale = {
          x: 1000,
          y: 10,
          z: 1000
        };
        let quat = {
          x: 0,
          y: 0,
          z: 0,
          w: 1
        };
        let mass = 0; //0(无限质量，静止物体)。

        //格子辅助线
        // var grid = new THREE.GridHelper(1000, 20, 0xffffff, 0xffffff);
        // grid.material.opacity = 0.5;
        // grid.material.transparent = true;
        // grid.position.y = 1;
        // scene.add(grid);


        const texture = textureLoader.load('./static/textures/WoodFlooring044/WoodFlooring044_COL_1K.jpg');
        // 重复模式
        texture.wrapS = THREE.RepeatWrapping; // 水平重复
        texture.wrapT = THREE.RepeatWrapping; // 水平重复
        // 重复
        texture.repeat.set(4, 4);
        // 位移贴图
        const displaceTexture = textureLoader.load('./static/textures/WoodFlooring044/WoodFlooring044_DISP_1K.jpg');
        // 导入粗糙度贴图
        const roughnessTexture = textureLoader.load('./static/textures/WoodFlooring044/WoodFlooring044_GLOSS_1K.jpg');
        // 法线贴图
        const normalTexture = textureLoader.load('./static/textures/WoodFlooring044/WoodFlooring044_NRM_1K.jpg');
        // 金属贴图
        const metaTexture = textureLoader.load('./static/textures/WoodFlooring044/WoodFlooring044_REFL_1K.jpg');

        //Create Threejs Plane
        let floorPlane = new THREE.Mesh(
          // new THREE.PlaneGeometry(1000, 1000),
          new THREE.BoxBufferGeometry(),
          new THREE.MeshStandardMaterial({
            // color: 0xFFA07A,
            // transparent: true,
            // opacity: 0.25,
            map: texture,
            // displacementMap: displaceTexture, // 位移贴图
            // displacementScale: 0, // 设置位移贴图对网格的影响
            roughnessMap: roughnessTexture, // 粗糙度贴图
            roughness: 0.8, // 粗糙度
            // normalMap: normalTexture, // 法线贴图
            metalness: 0.1, // 金属度
            metalnessMap: metaTexture, // 金属贴图
          })
        );
        floorPlane.scale.set(scale.x, scale.y, scale.z);
        // floorPlane.rotation.x = -Math.PI/2;
        floorPlane.position.set(pos.x, pos.y, pos.z);
        floorPlane.receiveShadow = true; //材质接收阴影
        this_.scene.add(floorPlane);

        // let helper = new VertexNormalsHelper( floorPlane, 2, 0x00ff00, 1 );
        // scene.add(helper)


        //屋顶
        function createRoofPlane() {
          const roofPlane = new THREE.Mesh(
            new THREE.BoxBufferGeometry(1000, 10, 1000),
            new THREE.MeshStandardMaterial({
              color: 0xFFFAFA,
              opacity: 0.75,
              transparent: true,
              roughness: 1, // 粗糙度
              metalness: 0, // 金属度
            })
          );
          roofPlane.position.set(pos.x, 440, pos.z);
          roofPlane.receiveShadow = true; //材质接收阴影
          this_.scene.add(roofPlane);
        }
        createRoofPlane();
      }



      function createWallMaterial() {
        let textureWall = textureLoader.load(
          './static/textures/BricksPaintedWhite001/BricksPaintedWhite001_COL_1K.jpg');
        // 重复模式
        // textureWall.wrapS = THREE.RepeatWrapping;// 水平重复
        // textureWall.wrapT = THREE.RepeatWrapping;// 水平重复
        // 重复
        // textureWall.repeat.set(8, 8);

        // 环境遮挡贴图
        const aoTextureWall = textureLoader.load(
          './static/textures/BricksPaintedWhite001/BricksPaintedWhite001_AO_1K.jpg');

        // 位移贴图
        const displaceTextureWall = textureLoader.load(
          './static/textures/BricksPaintedWhite001/BricksPaintedWhite001_DISP_1K.jpg');
        // 导入粗糙度贴图
        const roughnessTextureWall = textureLoader.load(
          './static/textures/BricksPaintedWhite001/BricksPaintedWhite001_GLOSS_1K.jpg');
        // 法线贴图
        const normalTextureWall = textureLoader.load(
          './static/textures/BricksPaintedWhite001/BricksPaintedWhite001_NRM_1K.jpg');
        // 金属贴图
        const metaTextureWall = textureLoader.load(
          './static/textures/BricksPaintedWhite001/BricksPaintedWhite001_REFL_1K.jpg');

        return new THREE.MeshStandardMaterial({
          color: 0x808080,
          opacity: 0.75,
          transparent: true,
          // map: textureWall,
          // bumpMap: aoTextureWall, // 环境遮挡贴图
          // // bumpScale: 1,
          // // displacementMap: displaceTextureWall, // 位移贴图
          // // displacementScale: 1, // 设置位移贴图对网格的影响
          // roughnessMap: roughnessTextureWall,// 粗糙度贴图
          // roughness: 1, // 粗糙度
          // normalMap: normalTextureWall, // 法线贴图
          // // metalness: 0, // 金属度
          // // metalnessMap: metaTextureWall, // 金属贴图
        })
      }

      //create X axis wall around entire plane
      function createWallX(x, y, z) {
        const wallScale = {
          x: 5,
          y: y * 2,
          z: 1007
        };
        const wall = new THREE.Mesh(
          new THREE.BoxBufferGeometry(wallScale.x, wallScale.y, wallScale.z),
          createWallMaterial()
        );
        wall.position.x = x;
        wall.position.y = y;
        wall.position.z = z;
        wall.receiveShadow = true;
        // wall.castShadow = true;
        // let helper = new VertexNormalsHelper( wall, 2, 0x008000, 1 );
        // scene.add(helper);
        this_.scene.add(wall);
        collideObjects.push(wall);
      }

      //create Z axis wall around entire plane
      function createWallZ(x, y, z) {
        const wallScale = {
          x: 1001,
          y: y * 2,
          z: 5
        };
        const wall = new THREE.Mesh(
          new THREE.BoxBufferGeometry(wallScale.x, wallScale.y, wallScale.z),
          createWallMaterial()
        );
        wall.position.x = x;
        wall.position.y = y;
        wall.position.z = z;
        wall.receiveShadow = true;
        // wall.castShadow = true;
        // let helper = new VertexNormalsHelper( wall, 2, 0xADFF2F, 1 );
        // scene.add(helper);
        this_.scene.add(wall);
        collideObjects.push(wall);
      }








      //document loading
      manager.onStart = function(item, loaded, total) {
        console.log("Loading started");
      };

      manager.onLoad = function() {
        console.log("Loading complete");
      };

      manager.onError = function(url) {
        console.log("Error loading", url);
      };


      /**
       * Animate
       */
      const clock = new THREE.Clock()
      let lastElapsedTime = 0
      const tick = () => {
        stats.update();
        const elapsedTime = clock.getElapsedTime();

        // samllBoll.position.x = Math.sin(elapsedTime) * 400;
        // samllBoll.position.z = Math.cos(elapsedTime) * 400;
        // console.log(samllBoll.position.y)
        const deltaTime = elapsedTime - lastElapsedTime;
        lastElapsedTime = elapsedTime;
        // let mixerUpdateDelta = clock.getDelta();


        if (characterControls) {

          // console.log(JSON.parse(JSON.stringify(deltaTime)))
          // console.log(JSON.parse(JSON.stringify(keysPressed)))
          characterControls.update(deltaTime, this_.keysPressed);

          socket.emit('message', {
            userid: this_.username, //角色id
            username: this_.player.name, //角色名字
            playerPosition: {
              x: characterControls.x,
              z: characterControls.z
            }, //角色位置
            fromAxisAngle: characterControls.fromAxisAngle, //四元数
            currentAction: characterControls.currentAction //角色动作状态
          });
        }
        for (let username in this.playerList) {
          var player = this.playerList[username]
          player.characterControlsOther.update(deltaTime,
            player.message.currentAction,
            player.message.fromAxisAngle,
            player.message.playerPosition.x,
            player.message.playerPosition.z);
        }

        // Update controls
        if (controls) controls.update()
        // Render
        if (renderer) {
          renderer.render(this_.scene, this_.camera)
        }
        labelRenderer.render(this_.scene, this_.camera);

        window.requestAnimationFrame(tick)

      }






      /**
       * 获取画布相对位置
       */
      function getCanvasRelativePosition(event) {
        const rect = renderer.domElement.getBoundingClientRect();
        return {
          x: ((event.clientX - rect.left) * renderer.domElement.width) / rect.width,
          y: ((event.clientY - rect.top) * renderer.domElement.height) / rect.height,
        };
      }

      const pickPosition = {
        x: 0,
        y: 0
      };

      //鼠标可以点击的位置
      const launchClickPositionRaycaster = new THREE.Raycaster();

      function launchClickPosition(event) {
        // console.log(event, 'event')
        const pos = getCanvasRelativePosition(event);
        pickPosition.x = (pos.x / renderer.domElement.width) * 2 - 1;
        pickPosition.y = (pos.y / renderer.domElement.height) * -2 + 1; // note we flip Y

        // cast a ray through the frustum
        launchClickPositionRaycaster.setFromCamera(pickPosition, this_.camera);
        // get the list of objects the ray intersected
        const intersectedObjects = launchClickPositionRaycaster.intersectObjects(this_.scene.children);
        // console.log(intersectedObjects, 'intersectedObjects')
        if (intersectedObjects.length) {
          // pick the first object. It's the closest one
          const pickedObject = intersectedObjects[0].object;
          // console.log(pickedObject,'pickedObject')
          if (pickedObject.userData.URL && (pickedObject.userData.videoIndex == 'video1' || pickedObject.userData.imageIndex == 'image1')) {
            // console.log(pickedObject.userData, pos)
            // sharedScreenFn(pickedObject.userData.videoIndex) //共享屏幕
            sharedScreenFn('video1') //共享屏幕
            // window.open(pickedObject.userData.URL);
          } else {
            return;
          }
        }
      }

      //鼠标悬浮手势
      const launchHoverRaycaster = new THREE.Raycaster();

      function launchHover(event) {
        event.preventDefault();
        var mouse = new THREE.Vector2();
        mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

        launchHoverRaycaster.setFromCamera(mouse, this_.camera);
        var intersects = launchHoverRaycaster.intersectObjects(this_.cursorHoverObjects);

        if (intersects.length > 0) {
          document.body.style.cursor = 'pointer';
        } else {
          document.body.style.cursor = 'default';
        }
      }

      setTimeout(() => {
        document.addEventListener('mousemove', launchHover);
      }, 1000);



      function handleKeyDown(event) {
        // keyDisplayQueue.down(event.key)
        if (event.shiftKey && characterControls) {
          characterControls.switchRunToggle()
        } else {
          this_.keysPressed[event.key.toLowerCase()] = true
          // console.log(keysPressed)
        }
      }

      function handleKeyUp(event) {
        this_.keysPressed[event.key.toLowerCase()] = false
      }

      window.addEventListener("keydown", handleKeyDown, false);
      window.addEventListener("keyup", handleKeyUp, false);
      document.addEventListener('click', launchClickPosition);
    },
    methods: {
      touchEvent(coordinates) { //手机移动
        this.moveDirection.right = coordinates.x > 30 ? 1 : 0;
        this.moveDirection.left = coordinates.x < -30 ? 1 : 0;
        this.moveDirection.back = coordinates.y > 30 ? 1 : 0;
        this.moveDirection.forward = coordinates.y < -30 ? 1 : 0;
        this.keysPressed['w'] = this.moveDirection.forward == 1;
        this.keysPressed['s'] = this.moveDirection.back == 1;
        this.keysPressed['a'] = this.moveDirection.left == 1;
        this.keysPressed['d'] = this.moveDirection.right == 1;
        return
        // if (coordinates.x > 30) {
        //   this.moveDirection.right = 1;
        //   this.moveDirection.left = 0;
        // } else if (coordinates.x < -30) {
        //   this.moveDirection.left = 1;
        //   this.moveDirection.right = 0;
        // } else {
        //   this.moveDirection.right = 0;
        //   this.moveDirection.left = 0;
        // }

        // if (coordinates.y > 30) {
        //   this.moveDirection.back = 1;
        //   this.moveDirection.forward = 0;
        // } else if (coordinates.y < -30) {
        //   this.moveDirection.forward = 1;
        //   this.moveDirection.back = 0;
        // } else {
        //   this.moveDirection.forward = 0;
        //   this.moveDirection.back = 0;
        // }
        // if(this.moveDirection.forward == 1){
        //   this.keysPressed['w'] = true
        // }else{
        //   this.keysPressed['w'] = false
        // }
        // if(this.moveDirection.back == 1){
        //   this.keysPressed['s'] = true
        // }else{
        //   this.keysPressed['s'] = false
        // }
        // if(this.moveDirection.left == 1){
        //   this.keysPressed['a'] = true
        // }else{
        //   this.keysPressed['a'] = false
        // }
        // if(this.moveDirection.right == 1){
        //   this.keysPressed['d'] = true
        // }else{
        //   this.keysPressed['d'] = false
        // }
      },
      handleMouseUp() {
        this.keysPressed['w'] = false
        this.keysPressed['s'] = false
        this.keysPressed['a'] = false
        this.keysPressed['d'] = false
      },
      socketMessage() {
        socket.on('message', (message) => {
          // console.log('socket-message收到的消息:',message)
          if (message.username == this.player.name) {
            return;
          }
          if (!this.playerList[message.username]) {
            console.log("自己：" + this.player.name, '创建角色:' + message.username)
            let player = new THREE.Group() //当前控制的角色
            player.name = message.username;
            let pos = {
              x: message.playerPosition.x,
              y: 0,
              z: message.playerPosition.z
            };
            this.createPlayer(player, pos);
            this.scene.add(player)
            let characterControlsOther = new CharacterControlsOther(
              player, player.mixer, player.animationsMap, message.currentAction); //idle

            this.playerList[message.username] = {
              player: player,
              characterControlsOther: characterControlsOther,
              message: message
            }
          } else {
            this.playerList[message.username].message = message;
          }
        });
      },
      createPlayer(player, pos) {
        let idle = this.gltf.animations[2];
        let run = this.gltf.animations[3];
        let walk = this.gltf.animations[6];
        const model = SkeletonUtils.clone(this.gltf.scene);
        model.rotation.y += Math.PI //旋转180度
        player.mixer = new THREE.AnimationMixer(model);

        player.animationsMap = new Map();
        player.animationsMap.set(idle.name, player.mixer.clipAction(idle))
        player.animationsMap.set(run.name, player.mixer.clipAction(run))
        player.animationsMap.set(walk.name, player.mixer.clipAction(walk))

        player.add(model)
        player.layers.enableAll();
        this.create2DObject(player);
        player.position.set(pos.x, pos.y, pos.z);
        this.mixers.push(player.mixer)

      },
      /**
       * 计算wasd这4个按键后的旋转角度
       * 计算规则：向前w 角度0    		w+a 逆时针45°   w+d 顺时针45°
       * 			向后s 角度逆时针180° 	s+a 逆时针135°  s+d 顺时针135°
       * 			向左a 逆时针90°
       * 			向右d 顺时针90°
       * @param keysPressed
       */
      directionOffset(keysPressed) {
        var directionOffset = 0 // w
        if (keysPressed['w']) {
          if (keysPressed['a']) {
            directionOffset = Math.PI / 4
          } else if (keysPressed['d']) {
            directionOffset = -Math.PI / 4
          }
        } else if (keysPressed['s']) {
          if (keysPressed['a']) {
            directionOffset = Math.PI / 4 + Math.PI / 2
          } else if (keysPressed['d']) {
            directionOffset = -Math.PI / 4 - Math.PI / 2
          } else {
            directionOffset = Math.PI
          }
        } else if (keysPressed['a']) {
          directionOffset = Math.PI / 2
        } else if (keysPressed['d']) {
          directionOffset = -Math.PI / 2
        }
        return directionOffset;
      },
      create2DObject(model) {
        const moonDiv = document.createElement('div');
        moonDiv.className = 'label';
        moonDiv.textContent = model.name;
        moonDiv.style.marginTop = '-1em';
        const moonLabel = new CSS2DObject(moonDiv);
        moonLabel.position.set(0, 90, 0);
        model.add(moonLabel);
        moonLabel.layers.set(0);
      },
      socketIo() { //建立
        console.log(socket, "建立连接成功");
        var this_ = this;
        setTimeout(() => {
          if (socket.connected) {
            console.log("连接成功");
            this_.socketMessage();
          }
        }, 1000)
      },
      initScene() { //创建一个新的场景对象
        // Scene
        this.scene = new THREE.Scene()
        this.scene.background = new THREE.Color(0xADD8E6);
        // scene.add(new THREE.AxesHelper(1005));//显示坐标轴辅助线（x轴为红色，z轴是蓝色，y轴是绿色
        // scene.fog = new THREE.FogExp2( 0xcccccc, 0.002 );//雾的效果
      },
      //function to create billboard
      createBillboard(x, y, z, rotation, url, path,imageIndex) { //创建四面屏幕（图片）
        /* default texture loading */
        const loader = new THREE.TextureLoader(manager);
        const texture = loader.load(path);
        texture.magFilter = THREE.LinearFilter;
        texture.minFilter = THREE.LinearFilter;
        var borderMaterial = new THREE.MeshBasicMaterial({
          color: 0x000000,
        });
        const loadedTexture = new THREE.MeshBasicMaterial({
          map: texture,
        });
        var materials = [
          borderMaterial, // Left side
          borderMaterial, // Right side
          borderMaterial, // Top side   ---> THIS IS THE FRONT
          borderMaterial, // Bottom side --> THIS IS THE BACK
          loadedTexture, // Front side
          borderMaterial, // Back side
        ];
        // order to add materials: x+,x-,y+,y-,z+,z-
        var billboardSignScale
        if(imageIndex == 'image1'){
          billboardSignScale = {
            x: 700,
            y: 320,
            z: 4
          };
        }else{
          billboardSignScale = {
            x: 400,
            y: 200,
            z: 5
          };
        }
        // const billboardSignScale = {
        //   x: 400,
        //   y: 200,
        //   z: 5
        // };
        const billboardSign = new THREE.Mesh(
          new THREE.BoxGeometry(
            billboardSignScale.x,
            billboardSignScale.y,
            billboardSignScale.z
          ),
          materials
        );
        billboardSign.position.x = x;
        billboardSign.position.y = y;
        billboardSign.position.z = z;

        /* Rotate Billboard */
        billboardSign.rotation.y = rotation;
        billboardSign.castShadow = true;
        billboardSign.receiveShadow = true;

        billboardSign.userData = {
          URL: url,
          imageIndex:imageIndex
        };

        this.cursorHoverObjects.push(billboardSign);
        this.scene.add(billboardSign);

      },
      /*创建四面屏幕（视频）
        参数：videoIndex:判断是那块屏幕
      */
      createBillboardVideo(x, y, z, rotation, path, url, videoIndex) {
        if (this.isPlay) {
          return
        }
        this.isPlay = true;
        console.log('视频链接及视频流：', path)
        // 创建video对象
        let videoElement = document.createElement('video')
        // document.getElementById(videoIndex).pause()
        // let videoElement = document.getElementById(videoIndex)
        // videoElement.pause()
        console.log('videoElement：', videoElement)
        if (!videoElement) {
          return
        }
        videoElement.muted = true
        videoElement.loop = true
        videoElement.controls = true
        videoElement.playsInline = true
        videoElement.autoplay = true

        // videoElement.src = path;
        if (typeof path == 'object') {
          try {
            if (this.scene && this.scene.children.length > 0) { //视频 图片切换显示
              // let videoIndex = this.scene.children.findIndex(item => item.userData.videoIndex == 'video1')
              // if (videoIndex >= 0) {
              //   this.scene.children[videoIndex].visible = true;
              // }
              let imageIndex = this.scene.children.findIndex(item => item.userData.imageIndex == 'image1')
              if (imageIndex >= 0) {
                this.scene.children[imageIndex].visible = false;
              }
              this.$forceUpdate()
            }
            videoElement.srcObject = path; //显示共享屏幕
            console.log('显示共享屏幕:', path)
            videoElement.load();
            setTimeout(function() {
              videoElement.play();               // console.log('播放执行后')
            }, 200);
          } catch (e) {
            console.log('error:', e)
            //TODO handle the exception
          }
        } else if (typeof path == 'string') {
           //  videoElement.src = "";
           if (this.scene && this.scene.children.length > 0) { //视频 图片切换显示
             // let videoIndex = this.scene.children.findIndex(item => item.userData.videoIndex == 'video1')
             // if (videoIndex >= 0) {
             //   this.scene.children[videoIndex].visible = false;
             // }
             this.scene.children.forEach((item) => {
               if(item.userData.videoIndex == 'video1'){
                 item.visible = false;
               }
             });
             let imageIndex = this.scene.children.findIndex(item => item.userData.imageIndex == 'image1')
             if (imageIndex >= 0) {
               this.scene.children[imageIndex].visible = true;
             }
            this.$forceUpdate()
           }
           this.isPlay = false
           return
        }
        setTimeout(() => {
          this.isPlay = false
        }, 1000);

        var borderMaterial = new THREE.MeshBasicMaterial({ //用于定义材质外观的对象
          color: 0x000000,
        });
        const videoTexture = new THREE.VideoTexture(videoElement); //创建一个使用视频来作为贴图的纹理对象
        // videoTexture.needsUpdate = true;
        // Material
        let videoMaterial = new THREE.MeshBasicMaterial({ //用于定义材质外观的对象
          map: videoTexture
        })
        var materials = [
          borderMaterial, // Left side
          borderMaterial, // Right side
          borderMaterial, // Top side   ---> THIS IS THE FRONT
          borderMaterial, // Bottom side --> THIS IS THE BACK
          videoMaterial, // Front side
          borderMaterial, // Back side
        ];

        // order to add materials: x+,x-,y+,y-,z+,z-
        // const billboardSignScale = {
        //   x: 400,
        //   y: 200,
        //   z: 5
        // };
        const billboardSignScale = {
          x: 700,
          y: 320,
          z: 5
        };

        const billboardSign = new THREE.Mesh(
          new THREE.BoxGeometry(
            billboardSignScale.x,
            billboardSignScale.y,
            billboardSignScale.z
          ),
          materials
        );
        billboardSign.position.x = x;
        billboardSign.position.y = y;
        billboardSign.position.z = z;

        /* Rotate Billboard */
        billboardSign.rotation.y = rotation;
        billboardSign.castShadow = true;
        // billboardSign.receiveShadow = true;
        billboardSign.userData = {
          URL: url,
          videoIndex: videoIndex,
          path: path
        };
        this.cursorHoverObjects.push(billboardSign);
        this.scene.add(billboardSign);
      }
    }
  }
</script>

<style scoped>
  #joystick-wrapper {
    border: 1px solid rgba(255, 255, 255, 0.5);
    width: 125px;
    height: 125px;
  position: fixed;
  bottom: 15px;
  left: 15px;
  text-align: center;
    border-radius: 100%;
    display: flex;
    /* [1] */
    justify-content: center;
    /* [2] */
    align-items: center;
  visibility: hidden;
    opacity: 1;
    z-index: 111;
  }

  #joystick {
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 100%;
    cursor: pointer;
    height: 45%;
  user-select: none;
  width: 45%;
  margin: 0 auto;
  visibility: hidden;
  opacity: 1;
  border: 1px solid rgba(255, 255, 255, 0.5);
  }
</style>



// WEBPACK FOOTER //
// src/components/test.vue